let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gMasl")).then(() => parcelRequire('5CImR'));